import React from "react";
import Tabs from '../Tabs/Tabs'
import DataTable from "../DataTable/DataTable";
import DateHelper from "../DateHelper/DateHelper";
import numeral from "numeral";
import EmailTab from "./EmailTab";

export default class VoucherPresenter extends React.Component {
  constructor(props){
    super(props);
    this.state = {
      activeTab: 'general',
    };
  };

  render() {
    return (
      <div className='VoucherBuilder' key='VoucherBuilder' >
        <div className="panel panel-form">
          <Tabs tabs={this.tabs()} />
          <div className='tab-content'>
            {this.renderTabContent()}
          </div>
        </div>
      </div>
    );
  };

  renderTabContent = () => {
    if (this.state.activeTab == 'general'){
      return this.renderGeneralTab();
    } else if (this.state.activeTab == 'purchasePayment'){
      return this.renderPurchasePaymentTab();
    } else if (this.state.activeTab == 'voucherPayments'){
      return this.renderVoucherPaymentsTab();
    } else if (this.state.activeTab == 'emails'){
      return this.renderVoucherEmailsTab();
    }else if (this.state.activeTab == 'notes'){
      return this.renderNotesTab();
    };
  };

  renderGeneralTab = () => {
    return (
      <div>
        <div className="row">
          <div className="col-md-2">
            <div className="form-group">
              <label>{I18n.t('amount')}*</label>
              <div>{this.formatCurrency(this.props.voucher.amount)}</div>
            </div>
          </div>
          <div className="col-md-3">
            <div className="form-group">
              <label>{I18n.t('customer')}</label>
              <div>{this.props.voucher.customer ? `${this.props.voucher.customer.first_name} ${this.props.voucher.customer.last_name} (${this.props.voucher.customer.email})` : I18n.t('none')}</div>
            </div>
          </div>
          <div className="col-md-3">
            <div className="form-group">
              <label>{I18n.t('expiration_date')}</label>
              <div>{this.props.voucher.expiration_date ? DateHelper.printDateToScreen(this.props.voucher.expiration_date, this.props.date_format) : I18n.t('none')}</div>
            </div>
          </div>
        </div>
        <hr />
        <div className="row">
          <div className="col-md-4">
            <div className="form-group">
              <label>{I18n.t("recipient_name")}*</label>
              <div>{this.props.voucher.recipient_name}</div>
            </div>
          </div>
          <div className="col-md-4">
            <div className="form-group">
              <label>{I18n.t("recipient_email")}*</label>
              <div>{this.props.voucher.recipient_email}</div>
            </div>
          </div>
          <div className="col-md-4">
            <div className="form-group">
              <label>{I18n.t("send_date")}*</label>
              <div>
                {this.props.voucher.delivery_date
                  ? DateHelper.printDateToScreen(
                    this.props.voucher.delivery_date,
                    this.props.date_format
                    )
                  : I18n.t("none")}
              </div>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-4">
            <div className="form-group" style={{marginBottom: '0px'}}>
              <label>{I18n.t("message")}</label>
              <div>{this.props.voucher.message}</div>
            </div>
          </div>
        </div>
      </div>
    );
  };

  renderPurchasePaymentTab = () => {
    return(
      <DataTable
        endpoint={this.props.purchase_payment_path}
        newRecord={false}
        no_data_text={I18n.t('none')}
        currency_unit={I18n.t('number.currency.format.unit')}
        delimiter={I18n.t('number.currency.format.delimiter')}
        separator={I18n.t('number.currency.format.separator')}
        date_format={this.props.date_format}
        time_format={this.props.time_format}
        read_only={true}
      />
    );
  };

  renderVoucherPaymentsTab = () => {
    return(
      <DataTable
        endpoint={this.props.voucher_payments_path}
        newRecord={false}
        no_data_text={I18n.t('none')}
        currency_unit={I18n.t('number.currency.format.unit')}
        delimiter={I18n.t('number.currency.format.delimiter')}
        separator={I18n.t('number.currency.format.separator')}
        date_format={this.props.date_format}
        time_format={this.props.time_format}
        read_only={true}
      />
    );
  };

  renderVoucherEmailsTab = () => {
    return(
      <EmailTab {...this.props} {...this.state} read_only={true}/>
    );
  };

  renderNotesTab = () => {
    return (
      <DataTable 
        endpoint={this.props.voucher_notes_path} 
        date_format={this.props.date_format} 
        time_format={this.props.time_format} 
        no_data_text={I18n.t('none')} 
        newRecord={false}
        read_only={true}
      />
    );
  };

  tabs = () => {
    return (
      [
        {
          tabName: I18n.t('general'),
          targetName: 'general',
          classes: this.state.activeTab === 'general' ? 'active' : null,
          changeHandler: this.onChangeTab,
        },
        {
          tabName: I18n.t('purchase_payment'),
          targetName: 'purchasePayment',
          classes: this.state.activeTab === 'purchasePayment' ? 'active' : null,
          changeHandler: this.onChangeTab,
        },
        {
          tabName: I18n.t('voucher_payments'),
          targetName: 'voucherPayments',
          classes: this.state.activeTab === 'voucherPayments' ? 'active' : null,
          changeHandler: this.onChangeTab,
        },
        {
          tabName: I18n.t('emails'),
          targetName: 'emails',
          classes: this.state.activeTab === 'emails' ? 'active' : null,
          changeHandler: this.onChangeTab,
        },
        {
          tabName: I18n.t('notes'),
          targetName: 'notes',
          classes: this.state.activeTab === 'notes' ? 'active' : null,
          changeHandler: this.onChangeTab,
        },
      ]
    );
  };

  onChangeTab = (tab) => {
    this.setState({ activeTab: tab });
  };

  formatCurrency = (num) => {
    return I18n.t('number.currency.format.unit') + numeral(num / 100).format('0' + I18n.t('number.currency.format.delimiter') + '0.00');
  };

};